var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"id":"return-copy"}},[_c('split-text',{attrs:{"type":'words',"classname":'question-copy'}},[_vm._v(_vm._s(_vm.copy))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }